import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { storeRankInitialState } from 'v3/data/store/Rank/RankStore/state';
import { IRankStoreList } from 'v3/data/store/Rank/RankStore/types';

export const rankStoreSlice = createSlice({
  name: 'rankStore',
  initialState: storeRankInitialState,
  reducers: {
    setRankStoreList: (state, action: PayloadAction<IRankStoreList>) => {
      state.list = action.payload;
      return state;
    },
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.filter.rowsPerPage = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setRankList: (state, action: PayloadAction<IRankStoreList>) => {
      state.list = action.payload;
      return state;
    },
  },
});
